import { Link } from 'expo-router';
import { domToReact } from 'html-react-parser';
import { cleanTextNodeData } from './cleanTextNodeData';

export function defaultHtmlReplacer(node) {
    if (node.type === "text") {
        const parentTag = node.parent?.name;
        
        if (["pre", "code", "textarea"].includes(parentTag)) 
            return;

        node.data = cleanTextNodeData(node.data);
        return node;
    }

    if (node?.name == 'a') {
        return (
            <Link push className="text-blue-500" target="_blank" href={node?.attribs?.href}>
                {domToReact(node.children || [])}
            </Link>
        )
    }

    return node;
}